/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * This module do HTTP requests modifying the request's data to handle bounding box fixes when the are
 * crosses the antimeridian line.
 * @ignore
 */
define([], function() {
    'use strict';

    function calculateBoundingBox(bBox) {
        if (bBox.minLon < -180) {
            return [
                { minLon: -180, minLat: bBox.minLat, maxLon: bBox.maxLon, maxLat: bBox.maxLat },
                { minLon: 360 + bBox.minLon, minLat: bBox.minLat, maxLon: 180, maxLat: bBox.maxLat }
            ];
        }

        if (bBox.maxLon > 180) {
            return [
                { minLon: bBox.minLon, minLat: bBox.minLat, maxLon: 180, maxLat: bBox.maxLat },
                { minLon: -180, minLat: bBox.minLat, maxLon: bBox.maxLon - 360, maxLat: bBox.maxLat }
            ];
        }

        return [bBox];
    }

    function splitOnEdgeOfTheWorld(bBox) {
        if (!bBox) {
            return [];
        }
        return calculateBoundingBox(bBox);
    }

    function responseCollector(numBoundingBoxes, responses, callback, model) {
        return function(response) {
            responses.push(response);
            if (responses.length === numBoundingBoxes) {
                responses = responses.length === 1 ? responses[0] : responses;
                callback(model(responses));
            }
        };
    }

    /**
     * @ignore
     * @param {Object} bbox
     * @param {Object} bbox.topLeftPoint
     * @param {Object} bbox.btmRightPoint
     * @return {LatLngBounds}
     */
    function unwrapBbox(bbox) {
        var wrappedBbox = {
            topLeftPoint: L.latLng(bbox.topLeftPoint.lat, bbox.topLeftPoint.lon).wrap(),
            btmRightPoint: L.latLng(bbox.btmRightPoint.lat, bbox.btmRightPoint.lon).wrap()
        };
        if (wrappedBbox.topLeftPoint.lng > 0 && wrappedBbox.btmRightPoint.lng < 0) {
            return {
                topLeftPoint: {
                    lat: wrappedBbox.topLeftPoint.lat,
                    lon: wrappedBbox.topLeftPoint.lng
                },
                btmRightPoint: {
                    lat: wrappedBbox.btmRightPoint.lat,
                    lon: wrappedBbox.btmRightPoint.lng + 360
                }
            };
        }
        return bbox;
    }

    /**
     * @ignore
     * @param {Object[]} results
     * @return {Object[]}
     */
    function unwrapBboxInResponse(results) {
        return results.map(function(result) {
            if (result.boundingBox) {
                result.boundingBox = unwrapBbox(result.boundingBox);
            }
            if (result.viewport) {
                result.viewport = unwrapBbox(result.viewport);
            }
            return result;
        });
    }

    /**
     * @ignore
     * It returns a new callback function that will handle the unwrapping of bbox values.
     * @param {Object} data
     * @param {Function} originalCallback
     * @return {Function}
     */
    function handleBboxUnwrapping(data, originalCallback) {
        if (data.unwrapBbox) {
            return function(results) {
                originalCallback(unwrapBboxInResponse(results));
            };
        }
        delete data.unwrapBbox;
        return originalCallback;
    }

    return function(service, model, data, callback, addBoundingBoxParameters) {
        var boundingBoxes = splitOnEdgeOfTheWorld(data.boundingBox),
            boundingBoxesLength = boundingBoxes.length || 1,
            responses = [],
            i;
        delete data.boundingBox;

        callback = handleBboxUnwrapping(data, callback);

        for (i = 0; i < boundingBoxesLength; i += 1) {
            data = boundingBoxes[i] ? addBoundingBoxParameters(data, boundingBoxes[i]) : data;
            service(data, responseCollector(boundingBoxesLength, responses, callback, model));
        }
    };
});



// WEBPACK FOOTER //
// ./services/worldEdge.js